module.exports = __webpack_public_path__ + "img/hiking.85d13968.jpg";